import { Mail, ExternalLink } from "lucide-react";
import { motion } from "framer-motion";
import {
  card,
  cardTitle,
  bodySecondary,
  dividerInner,
  iconSize,
  motionStaggerChild,
} from "../../../lib/design-system";
import { cn } from "../../../lib/utils";

const MentorDetails = ({ teacher }) => {
  if (!teacher) return null;

  const hasLinks =
    teacher.googleScholarLink || teacher.ScopusLink || teacher.LinkenInLink;

  const links = [
    { label: "Google Scholar", url: teacher.googleScholarLink },
    { label: "Scopus", url: teacher.ScopusLink },
    { label: "LinkedIn", url: teacher.LinkenInLink },
  ].filter((l) => l.url);

  return (
    <div className={cn(card, "overflow-hidden")}>
      {/* Header */}
      <div className={cn("p-6 border-b", dividerInner)}>
        <h3 className={cardTitle}>Instructor</h3>
      </div>

      {/* Body */}
      <div className="p-6 space-y-4">
        <motion.div {...motionStaggerChild(0)}>
          <p className="font-bold text-gray-900 dark:text-white text-lg">
            {teacher.name || ""}
          </p>
        </motion.div>

        {teacher.profTitle && (
          <motion.div {...motionStaggerChild(1)}>
            <p className={bodySecondary}>{teacher.profTitle}</p>
          </motion.div>
        )}

        {teacher.profDesc && (
          <motion.div {...motionStaggerChild(2)}>
            <p className={bodySecondary}>{teacher.profDesc}</p>
          </motion.div>
        )}

        {teacher.email && (
          <motion.div
            {...motionStaggerChild(3)}
            className="flex items-center gap-2"
          >
            <Mail className={cn(iconSize.xs, "text-gray-400")} />
            <span className={bodySecondary}>{teacher.email}</span>
          </motion.div>
        )}

        {hasLinks && (
          <motion.div
            {...motionStaggerChild(4)}
            className="flex flex-wrap gap-2 pt-1"
          >
            {links.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs font-medium text-accent1 bg-accent1/5 border border-accent1/20 hover:bg-accent1/10 transition-colors"
              >
                <ExternalLink className={iconSize.xs} />
                {link.label}
              </a>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default function MentorInfo({ teacher }) {
  return <MentorDetails teacher={teacher} />;
}
